import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./modules/auth/ProtectedRoute";
import { AppShell } from "./components/AppShell";
import { ClientShell } from "./components/ClientShell";
import { DashboardPage } from "./pages/DashboardPage";
import { ClientsPage } from "./pages/ClientsPage";
import { ClientDetailPage } from "./pages/ClientDetailPage";
import { ClientPortalPage } from "./pages/ClientPortalPage";
import { ClientProfilePage } from "./pages/ClientProfilePage";
import { ClientSettingsPage } from "./pages/ClientSettingsPage";
import { ClientMessagesPage } from "./pages/ClientMessagesPage";
import { CoachMessagesPage } from "./pages/CoachMessagesPage";
import { LoginPage } from "./pages/LoginPage";
import { ProfilePage } from "./pages/ProfilePage";
import { SettingsPage } from "./pages/SettingsPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute allowedRoles={["ADMIN", "COACH"]}>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/:clientId" element={<ClientDetailPage />} />
        <Route path="clients/:clientId/portal" element={<ClientPortalPage />} />
        <Route path="messages" element={<CoachMessagesPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route
        path="/client"
        element={
          <ProtectedRoute allowedRoles={["CLIENT"]}>
            <ClientShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<ClientPortalPage />} />
        <Route path="messages" element={<ClientMessagesPage />} />
        <Route path="profile" element={<ClientProfilePage />} />
        <Route path="settings" element={<ClientSettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
